(function(){
  /* ---- video lightbox (shared, one per page) ---- */
  var lb=null, lbFrame=null;
  function ensureLb(){
    if(lb){ return lb; }
    lb=document.createElement('div'); lb.className='baivd-lb';
    var inner=document.createElement('div'); inner.className='baivd-lb-in';
    lbFrame=document.createElement('div'); inner.appendChild(lbFrame);
    var close=document.createElement('button'); close.className='baivd-close'; close.setAttribute('aria-label','Close'); close.innerHTML='&times;';
    inner.appendChild(close); lb.appendChild(inner); document.body.appendChild(lb);
    function shut(){ lb.classList.remove('on'); lbFrame.innerHTML=''; }
    close.addEventListener('click',shut);
    lb.addEventListener('click',function(e){ if(e.target===lb){ shut(); } });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ shut(); } });
    return lb;
  }
  function openVideo(id){
    if(!id){ return; }
    ensureLb();
    lbFrame.innerHTML='<iframe src="https://www.youtube.com/embed/'+id+'?autoplay=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>';
    lb.classList.add('on');
  }

  function initVideos(root){
    if(root.__vd){ return; } root.__vd=1;
    var rail=root.querySelector('.baivd-rail');
    if(!rail){ return; }
    var originals=[].slice.call(rail.querySelectorAll('.baivd-card'));
    var N=originals.length;
    /* click (delegated so clones work too) */
    rail.addEventListener('click',function(e){
      var c=e.target.closest ? e.target.closest('.baivd-card') : null;
      if(c){ openVideo(c.getAttribute('data-yt')); }
    });

    var loop=N>2, seg=0, animating=false, ticking=false;

    function measure(){
      var cards=rail.querySelectorAll('.baivd-card');
      if(loop && cards.length>=N+1){ seg=cards[N].offsetLeft-cards[0].offsetLeft; }
    }

    if(loop){
      var before=document.createDocumentFragment(), after=document.createDocumentFragment();
      originals.forEach(function(c){ after.appendChild(c.cloneNode(true)); });
      originals.forEach(function(c){ before.appendChild(c.cloneNode(true)); });
      rail.appendChild(after);
      rail.insertBefore(before, rail.firstChild);
      measure();
      rail.scrollLeft=seg; /* start on the real (middle) set */
    }

    function wrap(){
      if(!loop||animating||!seg){ return; }
      if(rail.scrollLeft < seg*0.5){ rail.scrollLeft+=seg; }
      else if(rail.scrollLeft > seg*1.5){ rail.scrollLeft-=seg; }
    }
    rail.addEventListener('scroll',function(){
      if(ticking){ return; } ticking=true;
      requestAnimationFrame(function(){ ticking=false; wrap(); });
    });
    window.addEventListener('resize',function(){ measure(); });
    window.addEventListener('load',function(){ measure(); if(loop){ rail.scrollLeft=seg; } });

    function step(dir){
      var card=rail.querySelector('.baivd-card');
      var w=card?(card.offsetWidth+20):320;
      wrap();
      animating=true;
      rail.scrollTo({left:rail.scrollLeft + dir*w*1.6, behavior:'smooth'});
      setTimeout(function(){ animating=false; wrap(); }, 520);
    }
    var prev=root.querySelector('.baivd-nav.prev'), next=root.querySelector('.baivd-nav.next');
    if(prev){ prev.addEventListener('click',function(){ step(-1); }); }
    if(next){ next.addEventListener('click',function(){ step(1); }); }
  }

  function initReviews(root){
    if(root.__rv){ return; } root.__rv=1;
    root.querySelectorAll('.bairev-card').forEach(function(card){
      var q=card.querySelector('.bairev-quote');
      var btn=card.querySelector('.bairev-more');
      if(!q||!btn){ return; }
      if(q.scrollHeight-q.clientHeight<8){ btn.style.display='none'; return; }
      btn.addEventListener('click',function(){
        var open=card.classList.toggle('open');
        btn.textContent=open?'Read less':'Read more';
      });
    });
  }

  function boot(){
    [].slice.call(document.querySelectorAll('.baivd')).forEach(initVideos);
    [].slice.call(document.querySelectorAll('.bairev')).forEach(initReviews);
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded',boot); }
})();
